var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 30.375H3.375V34.875H7.875V30.375Z",
    fill: "#7BFBF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 28.6875H11.8125V34.875H16.3125V28.6875Z",
    fill: "#7BFBF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 26.4375H20.25V34.875H24.75V26.4375Z",
    fill: "#7BFBF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1875 21.375H28.6875V34.875H33.1875V21.375Z",
    fill: "#7BFBF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4688 10.125H21.9375V15.75H24.4688V10.125Z",
    fill: "#7BFBF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7188 10.125H25.0312V15.75H26.7188V10.125Z",
    fill: "#7BFBF4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8125 10.125H27.2812V15.75H29.8125V10.125Z",
    fill: "#7BFBF4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8758 10.097L16.8747 10.142L18 10.125C17.9995 9.44249 18.0876 8.76281 18.262 8.10296L17.1744 7.81458C16.9769 8.55933 16.8765 9.32649 16.8758 10.097Z",
    fill: "#7BFBF4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8835 19.125L25.875 18C25.1898 18.0005 24.5075 17.9117 23.8453 17.736L23.5558 18.8231C24.3125 19.0239 25.0921 19.1254 25.875 19.125H25.8835Z",
    fill: "#7BFBF4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5209 1.43616C22.7617 1.64142 22.0329 1.9459 21.3533 2.34171L21.9191 3.314C22.5133 2.96791 23.1505 2.70167 23.8142 2.52216L23.5209 1.43616Z",
    fill: "#7BFBF4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4839 12.1627L34.5709 12.4527C34.7731 11.6934 34.8753 10.9108 34.875 10.125V10.0909L33.75 10.125C33.7504 10.8129 33.6609 11.498 33.4839 12.1627Z",
    fill: "#7BFBF4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6536 5.59534L32.6819 6.16223C33.0285 6.75608 33.2953 7.393 33.4756 8.05654L34.5611 7.76156C34.3551 7.00276 34.0499 6.27441 33.6536 5.59534Z",
    fill: "#7BFBF4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2166 3.73892C31.6589 3.1849 31.0312 2.70615 30.3495 2.31482L29.7897 3.29041C30.3864 3.63305 30.9358 4.05215 31.4239 4.53708L32.2166 3.73892Z",
    fill: "#7BFBF4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.184 12.4709C17.3886 13.2302 17.6923 13.9593 18.0874 14.6393L19.0602 14.0741C18.7147 13.4798 18.4492 12.8425 18.2706 12.1786L17.184 12.4709Z",
    fill: "#7BFBF4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1766 1.42218C27.4254 1.22444 26.6518 1.12455 25.875 1.125H25.8495L25.875 2.25C26.5548 2.2495 27.2319 2.33683 27.8893 2.50983L28.1766 1.42218Z",
    fill: "#7BFBF4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6978 14.0603C32.3533 14.656 31.9324 15.2041 31.4459 15.6907L32.2418 16.4861C32.7974 15.93 33.2781 15.3038 33.6717 14.6234L32.6978 14.0603Z",
    fill: "#7BFBF4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3813 17.9173L29.8172 16.944C29.2224 17.2888 28.5847 17.5537 27.9207 17.732L28.2123 18.8185C28.9717 18.6146 29.701 18.3116 30.3813 17.9173Z",
    fill: "#7BFBF4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0443 6.20346C19.3876 5.60713 19.8073 5.0582 20.2929 4.57062L19.4952 3.77686C18.9408 4.33396 18.4615 4.96098 18.0692 5.64205L19.0443 6.20346Z",
    fill: "#7BFBF4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5205 16.4982C20.0769 17.0533 20.7035 17.5333 21.3843 17.9261L21.9463 16.9516C21.3504 16.6077 20.802 16.1875 20.3148 15.7017L19.5205 16.4982Z",
    fill: "#7BFBF4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02716 23.0625H13.5C13.6217 23.0624 13.7402 23.0229 13.8376 22.9499L17.2143 20.4173L16.8827 22.4074L17.9923 22.5926L18.5548 19.2176C18.5793 19.0704 18.5444 18.9196 18.4577 18.7982C18.3711 18.6768 18.2397 18.5948 18.0926 18.5702L14.7176 18.0077L14.5324 19.1173L16.611 19.4637L13.3124 21.9375H7.875C7.77539 21.9374 7.67756 21.9639 7.59155 22.0141L0.841553 25.9516L1.40845 26.9233L8.02716 23.0625Z",
    fill: "#7BFBF4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7188 6.74998L27.5999 5.53077C27.6802 5.39669 27.8094 5.29896 27.9603 5.2581C28.1112 5.21724 28.272 5.23643 28.409 5.31165C28.5461 5.38686 28.6486 5.51225 28.6952 5.66148C28.7417 5.81071 28.7286 5.97217 28.6587 6.11195L28.125 6.74998H27.2812V9.56248H30.9375V6.74998H29.5976L29.665 6.61512C29.865 6.21516 29.9023 5.75329 29.769 5.32644C29.6358 4.89959 29.3424 4.54093 28.9504 4.32574C28.5584 4.11055 28.0983 4.05554 27.6667 4.17227C27.235 4.289 26.8654 4.56839 26.6353 4.95181L25.8929 6.18931L25.1505 4.95181C24.9203 4.56847 24.5507 4.28916 24.119 4.17248C23.6874 4.0558 23.2274 4.11082 22.8354 4.32599C22.4435 4.54116 22.1501 4.89976 22.0169 5.32655C21.8836 5.75335 21.9208 6.21517 22.1207 6.61512L22.1881 6.74998H20.8125V9.56248H24.4688V6.74998H23.625L23.127 6.11195C23.0571 5.97217 23.0441 5.81074 23.0906 5.66154C23.1372 5.51234 23.2397 5.38698 23.3767 5.31177C23.5137 5.23657 23.6746 5.21737 23.8254 5.2582C23.9763 5.29904 24.1055 5.39673 24.1859 5.53077L25.0312 6.74998V9.56248H26.7188V6.74998Z",
    fill: "#7BFBF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.7d37fcc9f8d4b4aa2b7739cf084b06d7.svg";
export { ForwardRef as ReactComponent };